import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const toTop = () => {
    const lenis = window.__lenis;
    if (lenis) lenis.scrollTo(0, { duration: 1.4 });
    else window.scrollTo({ top: 0, behavior: "auto" });
  };

  return (
    <button
      type="button"
      onClick={toTop}
      className={`back-to-top ${visible ? "is-visible" : ""}`}
      data-testid="back-to-top-fab"
      aria-label="Back to top"
    >
      <ArrowUp size={18} strokeWidth={1.8} />
      <span className="back-to-top__ring" aria-hidden />
    </button>
  );
}
